import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Text } from '@bonusly/design-system';

interface PaginationButtonProps {
	currentPage?: number;
	pageNumber?: number;
	handleSelection: (event: { currentTarget: { id: any } }) => void;
}

export const PaginationButton: FC<PaginationButtonProps> = ({ currentPage, pageNumber, handleSelection }) => {
	const { t } = useTranslation('rewards');
	const isCurrentPage = currentPage === pageNumber;

	const buttonStyles = {
		color: isCurrentPage ? 'primary.fgStrong' : 'text.default',
		background: isCurrentPage ? 'primary.bgAlpha' : 'transparent',
		_hover: {
			color: isCurrentPage ? 'primary.fgStrongest' : 'text.default',
			background: isCurrentPage ? 'primary.bgAlphaHover' : 'secondary.bgAlphaHover',
		},
		_active: {
			color: isCurrentPage ? 'primary.fgStrongest' : 'text.default',
			background: isCurrentPage ? 'primary.bgAlpha' : 'secondary.bgAlpha',
		},
		_disabled: {
			color: isCurrentPage ? 'secondary.fg' : 'text.default',
			background: isCurrentPage ? 'secondary.bgAlpha' : 'transparent',
			opacity: 0.5,
		},
	};

	return (
		<Box key={pageNumber}>
			<Button
				_focus={{ border: 'none' }}
				aria-current={!!isCurrentPage}
				aria-label={isCurrentPage ? t('pagination.current_page', { page_number: currentPage }) : t('pagination.go_to_page', { page_number: pageNumber })}
				borderRadius="full"
				id={`${pageNumber}`}
				onClick={handleSelection}
				{...buttonStyles}
			>
				<Text fontSize={100} fontWeight="medium" lineHeight={4}>
					{pageNumber}
				</Text>
			</Button>
		</Box>
	);
};
